export const USERS_API_BASE_ADDRESS = 'http://localhost:3001';
export const USERS_ENDPOINT = 'users';
export const LOCAL_STORAGE_KEY = '__books_token__';
export const TOKEN_START_POINT = 'Books';
// export const USERS_AUTH_BASE_ADDRESS = 'http://localhost:3001';
// export const USERS_AUTH_ENDPOINT = 'users';
export const USERS_AUTH_BASE_ADDRESS = 'https://my-json-server.typicode.com/dzsilkov/data/';
export const USERS_AUTH_ENDPOINT = 'users';

